import React from "react";
import ProductTab from "../components/productdetails/ProductTab";
import ProductInfo from "../components/productdetails/productinfo";
import Banner from "../components/comman/Banner";

const ProductDetails = () => {
    return (
        <div>
            <Banner title="Product Details" />
            <ProductInfo />
            <ProductTab />
        </div>
    );
};

export default ProductDetails;
